export const REPORT_SECTIONS = [
  'RESULT_SUMMARY',
  'ABOUT',
  'MATCHED_SOURCES',
  'HIGHLIGHTED_TEXT',
  'REFERENCES_AND_CITATION_TOOL',
  'SCAN_SETTINGS',
] as const;

export type ReportSection = (typeof REPORT_SECTIONS)[number];

export const REPORT_SECTION_LABELS: Record<ReportSection, string> = {
  RESULT_SUMMARY: 'Analysis report',
  ABOUT: 'How it works',
  MATCHED_SOURCES: 'Matched sources',
  HIGHLIGHTED_TEXT: 'Highlighted text',
  REFERENCES_AND_CITATION_TOOL: 'References',
  SCAN_SETTINGS: 'Scan settings',
};
